<template>
    <div id="order-package-wiki-modal">
        <modal :backdrop="false" size="lg" v-model="modal">
            <div slot="header">
                <button @click.prevent="closeModal" class="close" type="button">×</button>
                <div class="row">
                    <div class="col-xs-12"><h4 class="smalltitle">Choose Wiki Package for {{ group.fullName }}</h4></div>
                </div>
            </div>
            <div class="block-body">
              <div class="prolabel note">Choose package(s)</div>
              <div class="profield">
                <multi-select v-model="dataInfo.listPackageId"
                              :filterable="true"
                              :options="listPackages"
                              :append-to-body="true"
                              block
                              class="multi-select-block"
                              placeholder="Select package(s)..."
                              selected-icon=""
                >
                  <template slot="option" slot-scope="{ item }">
                    <span class="wiki-package-option">
                      <input type="checkbox"
                             :checked="isPackageSelected(item)"
                             tabindex="-1"
                             class="wiki-package-option__checkbox"
                             @click.prevent>
                      <span>{{ item.label }}</span>
                    </span>
                  </template>
                </multi-select>
              </div>
            </div>
            <div slot="footer">
                <button type="button" class="btn btn-default" @click="savePackages">
                  <i class="fas fa-spinner fa-spin" v-if="isProcessing"></i> Update
                </button>
                <button @click.prevent="closeModal" class="btn btn-default" type="button">Close</button>
            </div>
        </modal>
    </div>
</template>

<script>
import httpClient from '../../../client'
import CommonMixin from '../../../mixins/general/CommonMixin.vue'

export default {
  name: 'OrderPackageWikiModal',
  mixins: [CommonMixin],
  props: {
    group: {}
  },
  data () {
    return {
      modal: false,
      listPackages: [],
      dataInfo: {
        listPackageId: []
      },
      isProcessing: false
    }
  },
  watch: {
    modal (newValue) {
      this.$emit('updateModal', newValue)
    }
  },
  mounted () {
    this.modal = true
    this.getDataPackages()
  },
  methods: {
    isPackageSelected (item) {
      return this.dataInfo.listPackageId.indexOf(item.value) >= 0
    },
    async savePackages () {
      if (this.isProcessing) return
      this.isProcessing = true
      try {
        let response = await httpClient.post(`/wiki-group/add-package-wiki`, {
          groupId: this.group.id,
          listPackageId: this.dataInfo.listPackageId
        })
        this.isProcessing = false
        if (response.data.s === 200) {
          this.alertSuccess(response.data.msg)
          this.modal = false
          return
        }
        this.alertError(response.data.msg)
      } catch (e) {
        this.isProcessing = false
        this.alertError('Server error. Try again later')
      }
    },
    async getDataPackages () {
      try {
        let response = await httpClient.get(`/wiki-group/init-order-package-wiki`, {
          params: { groupId: this.group.id }
        })
        if (response.data.s === 200) {
          const packages = response.data.data.packages
          this.listPackages = packages.map(item => ({
            label: item.name,
            value: Number(item.id)
          }))
          const listPackageIds = response.data.data.groupWikiPackage.listPackageId || []
          this.dataInfo.listPackageId = listPackageIds
            .map(id => Number(id))
            .filter(packageId => {
              return this.listPackages.findIndex(item => item.value === packageId) >= 0
            })
        }
      } catch (e) {
        console.log(e.message)
      }
    },
    closeModal () {
      this.modal = false
    }
  }
}
</script>
<style>
#order-package-wiki-modal .multi-select-block .dropdown-toggle {
  border-radius: 0px !important;
}
#order-package-wiki-modal .multi-select-block > .form-control {
  padding: 8px 10px;
  border-radius: 0px !important;
}
#order-package-wiki-modal .wiki-package-option {
  display: flex;
  align-items: center;
  margin: 0;
  cursor: pointer;
  font-weight: normal;
}
#order-package-wiki-modal .wiki-package-option__checkbox {
  margin: 0 8px 0 0;
  pointer-events: none;
}
</style>
